import { ChangeDetectionStrategy, Component, computed, input, output, TemplateRef } from '@angular/core';
import { NgComponentOutlet, NgTemplateOutlet } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { ButtonComponent } from '../button/button.component';
import { TButtonColor, TRenderComponent } from '@dss-libs/shared/type/common-types';

@Component({
  selector: 'dss-libs-ui-base-modal',
  imports: [NgTemplateOutlet, NgComponentOutlet, ButtonComponent, MatIconModule, TranslocoDirective],
  templateUrl: './base-modal.component.html',
  styleUrl: './base-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseModalComponent {
  readonly headerPadding = input<string>('px-6 py-4');
  readonly header = input<TemplateRef<unknown> | TRenderComponent<unknown> | string>();
  readonly subtitle = input<string | undefined>();
  readonly actions = input<TemplateRef<unknown>>();
  readonly primaryTitle = input<string | undefined>();
  readonly primaryButtonColor = input<TButtonColor>('primary');
  readonly primaryDisabled = input<boolean>(false);
  readonly isLoading = input<boolean>(false);
  readonly secondaryTitle = input<string | undefined>();
  readonly secondaryButtonColor = input<TButtonColor>('gray');
  readonly showClose = input<boolean>(true);

  readonly primarySubmitted = output<void>();
  readonly secondarySubmitted = output<void>();
  readonly closed = output<void>();

  readonly isHeaderTemplate = computed<TemplateRef<unknown> | undefined>(() => {
    const header = this.header();
    return header instanceof TemplateRef ? header : undefined;
  });

  readonly headerClasses = computed(
    () => `flex items-center justify-between border-b border-stroke ${this.headerPadding()}`
  );

  readonly headerComponent = computed<TRenderComponent<unknown> | undefined>(() => {
    const header = this.header();
    return typeof header !== 'string' && !(header instanceof TemplateRef) ? header : undefined;
  });
}
